import { useMutation } from '@tanstack/react-query';

import type { ExportCsvResponse } from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useExportSpecialistPayoutsTmpCsvMutation = () =>
  useMutation({
    mutationFn: ({
      url,
      filters,
    }: {
      url: string;
      filters: Record<string, unknown>;
    }) =>
      HttpClient.request<ExportCsvResponse>({
        method: 'POST',
        url,
        data: { specialist_payout_tmp_export: { filters } },
      }),
  });
